import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatSelect } from '@angular/material/select';
import { AuthService } from '@core/auth/auth.service';
import { FieldTypeConfig } from '@ngx-formly/core';
import { FieldType } from '@ngx-formly/material';
import { SelectOptionsFieldProps } from '@shared/components/data-form/data-form.model';
import { CustomCreditCardDrawerComponent } from '@shared/components/page-layout/drawers/custom-credit-card-drawer/custom-credit-card-drawer.component';
import { PageLayoutService } from '@shared/components/page-layout/page-layout.service';

import { MatButton } from '@angular/material/button';
import { MatOption } from '@angular/material/core';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-credit-card',
    templateUrl: './credit-card.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatFormField, MatLabel, MatSelect, FormsModule, ReactiveFormsModule, MatOption, MatButton, MatIcon]
})
export class CreditCardComponent extends FieldType<FieldTypeConfig<SelectOptionsFieldProps & { isAdmin?: boolean; userId?: string }>> {
  private layoutService = inject(PageLayoutService);
  private authService = inject(AuthService);


  addNewCard() {
    this.layoutService.navigateParentDrawer({
      component: CustomCreditCardDrawerComponent,
      smallDrawer: true,
      data: {
        userCreditCard: null,
        isCustomer: !(this.field?.props?.['isAdmin'] ?? false),
        userId: this.field?.props?.['userId'] ?? this.authService?.userProfile?.user?.id,
      }
    });
  }
}
